<div class="col-sm-12 detail" *ngIf="!isEmpty && !edit" style="height: calc(100% - 10%);   padding: 0 5px;" (click)="common.outSide($event)">
    <div class="header col-sm-12" style=" padding: 11px;">
      <div class="col-sm-9">
        <h2> Contacts de : {{ detail.nomClient || '' }} </h2>
      </div>
      <div class="col-sm-3 text-right" style=" padding: 0;">
        <button class="btn-header uppercase" id="closePanelContact" (click)="hideContact()" style="margin-right: 5px"> Fermer </button>
        <button class="btn-header uppercase actionPricipal" id="valide" [ngClass]="{'disabledbutton': !isedit}" (click)="addLigne()"> Créer </button>
      </div>
    </div>
    
    <div class="col-sm-12 text-right" style="padding: 0;">
        <label class="uppercase text-underline historique" (click)="showHisto()">
            <span *ngIf="!isHisto"> Voir l'historique </span>
            <span *ngIf="isHisto"> Voir les contacts actifs </span>
        </label>
    </div>    
    
    <div class="col-sm-12 ligneBon liste tab-content" style="background-color: #FFF" *ngIf="!isHisto">
        <div class="wrap_ligneListeContact" *ngFor="let row of listeContact">
            <div class="ligneListeContact">
                <div class="form-group-contact items" style="font-size: 20px; font-weight: bold">
                  {{ (row.civilite && row.civilite.id && row.civilite.id > 0) ? (row.civilite.libelle || row.civilite.libelleObjetEntite) : '' }} {{ row.nom || '' }} {{ row.prenom }}
                  <span class="items text-right"  [ngClass]="{'disabledbutton': !isedit}" style="float: right">
                    <button class="btn-detail" (click)="deleteLigne(row)"><i class="fa fa-trash"></i></button>&nbsp;
                    <button class="btn-detail" (click)="editer(row);"><i class="fa fa-pencil"></i></button>                    
                  </span>
                </div>              
                <div class="form-group-contact items">
                  {{ row.fonction || '' }}
                </div>                           
                <div class="form-group-contact items">
                  {{ row.adresse1 || '' }}
                </div>                                        
                <div class="form-group-contact items">
                  {{ row.adresse2 || '' }}
                </div>           
                <div class="form-group-contact items">
                  {{ row.adresse3 || '' }}
                </div>   
                <div class="form-group-contact items">
                  {{ row.CP }} {{ row.ville }}
                </div>    
                <div class="form-group-contact items">
                  {{ row.portable || '' }}
                </div>                         
                <div class="form-group-contact items">
                  {{ row.tel || '' }}
                </div>         
                <div class="form-group-contact items">
                  {{ row.mail || '' }}
                </div>                         
                <div class="form-group-contact items">
                  {{ row.fax || '' }}
                </div>               
                <div *ngIf="!isDepuisFicheChantier" class="form-group-contact items">
                  {{ (row.chantier && row.chantier.libelleObjetEntite && row.chantier.libelleObjetEntite != 'undefined' ? row.chantier.libelleObjetEntite : '') }}
                </div>             
                <div class="form-group-contact items">
                  {{ (row.commercial && row.commercial.libelleObjetEntite && row.commercial.libelleObjetEntite != 'undefined' ? row.commercial.libelleObjetEntite : '') }} 
                  <span class="text-underline historique" (click)="getChampsCltSupp(row)">Champs supp</span>
                </div>
            </div>
        </div>        
    </div>
    
    <div class="col-sm-12 ligneBon liste tab-content" style="background-color: #FFF" *ngIf="isHisto">
        <div class="wrap_ligneListeContact" *ngFor="let row of listeContactHisto">
            <div class="ligneListeContact">
                <div class="form-group-contact items" style="font-size: 20px; font-weight: bold">
                  {{ (row.civilite && row.civilite.id && row.civilite.id > 0) ? (row.civilite.libelle || row.civilite.libelleObjetEntite) : '' }} {{ row.nom || '' }} {{ row.prenom }}
                </div>                  
                <div class="form-group-contact items">
                  {{ row.fonction || '' }}
                </div>                           
                <div class="form-group-contact items">
                  {{ row.adresse1 || '' }}
                </div>                                        
                <div class="form-group-contact items">
                  {{ row.adresse2 || '' }}
                </div>           
                <div class="form-group-contact items">
                  {{ row.adresse3 || '' }}
                </div>   
                <div class="form-group-contact items">
                  {{ row.CP }} {{ row.ville }}
                </div>    
                <div class="form-group-contact items">
                  {{ row.portable || '' }}
                </div>                         
                <div class="form-group-contact items">
                  {{ row.tel || '' }}
                </div>         
                <div class="form-group-contact items">
                  {{ row.mail || '' }}
                </div>                         
                <div class="form-group-contact items">
                  {{ row.fax || '' }}
                </div>               
                <div *ngIf="!isDepuisFicheChantier" class="form-group-contact items">
                  {{ (row.chantier && row.chantier.libelleObjetEntite && row.chantier.libelleObjetEntite != 'undefined' ? row.chantier.libelleObjetEntite : '') }}
                </div>             
                <div class="form-group-contact items">
                  {{ (row.commercial && row.commercial.libelleObjetEntite && row.commercial.libelleObjetEntite != 'undefined' ? row.commercial.libelleObjetEntite : '') }} 
                  <span class="text-underline historique" (click)="getChampsCltSupp(row)">Champs supp</span>
                </div>
            </div>
        </div>        
    </div>
</div>

<div class="col-sm-12 detail" *ngIf="edit" style="height: 100%;   padding: 0 5px;" (click)="common.outSide($event)">
    <div class="header col-sm-12">
      <div class="col-sm-7">
        <h2> {{ !contactSelected.id ? 'Ajout d\'un contact' : 'Modifier un contact' }} </h2>
      </div>
      <div class="col-sm-5 text-right" style=" padding: 0;">
        <button class="btn-header uppercase" id="closeAjoutModifContact" (click)="hideFenetreContact()"> Fermer </button>
        <button class="btn-header uppercase actionPricipal" id="valide" (click)="validerFenetreContact()"> Valider </button>
      </div>
    </div>
  
    <div class="col-sm-12 liste" style="padding-top: 15px; background-color: #FFF">
        <div class="group1">
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Civilité :</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div *ngIf="edit">
                        <app-autocomplete (searchfunction)="searchCivilite($event)" (selectfunction)="contactSelected.civilite = $event"
                            [results]="listCivilite" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
                            [defaultselected]="contactSelected.civilite" [disablefocus]="true"
                            [defaultsearch]="contactSelected.civilite ? contactSelected.civilite.libelle : ''"></app-autocomplete>
                    </div>
                </div>
            </div>        
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Nom</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contactSelected.nom">
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Prénom :</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contactSelected.prenom">
                </div>
            </div>            
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Tél :</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contactSelected.tel">
                </div>
            </div>              
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Fax :</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contactSelected.fax">
                </div>
            </div>              
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Portable :</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contactSelected.portable">
                </div>
            </div>    
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Mail :</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contactSelected.mail">
                </div>
            </div>              
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Fonction :</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contactSelected.fonction">
                </div>
            </div>              
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Adresse 1 :</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contactSelected.adresse1">
                </div>
            </div>              
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Adresse 2 :</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contactSelected.adresse2">
                </div>
            </div>                          
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Adresse 3 :</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="contactSelected.adresse3">
                </div>
            </div>                          
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">CP</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div *ngIf="edit">
                        <app-autocomplete-cp-ville [cp]="'CP'" [item]="contactSelected" [ville]="'ville'" [iscp]="true">
                        </app-autocomplete-cp-ville>
                    </div>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Ville</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div *ngIf="edit">
                        <app-autocomplete-cp-ville [cp]="'CP'" [item]="contactSelected" [ville]="'ville'">
                        </app-autocomplete-cp-ville>
                    </div>
                </div>
            </div>    
            <div *ngIf="!isDepuisFicheChantier"  class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Chantier</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div *ngIf="edit">
                        <app-autocomplete [placeholder]="contactSelected.chantier ? '' : 'Chantier'" (searchfunction)="searchChantier($event)" (selectfunction)="choisirChantier($event);"
                            [notOblig]="true" [label]="''" [selectvalue]="true" [container]="true" [showonclick]="true" [results]="listChantier"
                            [defaultsearch]="contactSelected.chantier ? (contactSelected.chantier.libelle || contactSelected.chantier.libelleObjetEntite || '') : ''" [autohide]="true" [disablefocus]="true"></app-autocomplete>
                    </div>
                </div>
            </div>             
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Commerciale</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div *ngIf="edit">
                        <app-autocomplete [placeholder]="''" (selectfunction)="contactSelected.commercial = $event;" [results]="listeCommercial"
                            [label]="''" [defaultselected]="contactSelected.commercial" [container]="true"
                            [isCombo]="true" [highlight]="true" [defaultsearch]="contactSelected.commercial ? (contactSelected.commercial.libelleObjetEntite || contactSelected.commercial.libelle || '') : ''"></app-autocomplete>
                    </div>
                </div>
            </div>                
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">Champs. supp</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <div *ngIf="edit">
                        <div class="text-underline historique" (click)="getChampsCltSupp(contactSelected)">
                            Définir
                        </div>
                    </div>
                </div>
            </div>             
        </div>        
    </div>
</div>    

<app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>
<ng-template #champSupp>
    <div class="modal-header">
          <h4 class="modal-title pull-left"> Champs Supp du contact  : {{ contactSelected.nom }} </h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
              <span aria-hidden="true">&times;</span>
          </button>
    </div>
    <div class="modal-body modalFicheClient" style="height: auto">
          <div class="col-sm-12" style="padding: 0px; height: 405px;  overflow: auto;">
                  <div class="col-sm-12 form-group" *ngFor="let item of listChampSupp">
                      <div class="col-sm-1" *ngIf="!item.masque">
                          <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                              [(ngModel)]="item.actif" [disabled]="isHisto">
                      </div>
                      <div class="col-sm-11" *ngIf="!item.masque">
                          <label class="text"> {{item.nom}} </label>
                          <input type="number" class="form-control" *ngIf="item.type === 1" [value]="getValueChampsupp(item.id)"
                              placeholder="{{item.nom}}" [(ngModel)]="item.valeur" [disabled]="!item.actif || isHisto"
                              (ngModelChange)="changeFiliere()" />
                          
                          <input type="text" class="form-control" [(ngModel)]="item.valeur" *ngIf="item.type !== 1 && item.type !== 3"
                              [value]="getValueChampsupp(item.id)" placeholder="{{item.nom}}"
                              [disabled]="!item.actif || isHisto" (ngModelChange)="changeFiliere()" />
                              
                          <textarea class="form-control" [(ngModel)]="item.valeur" *ngIf="item.type === 3" [value]="getValueChampsupp(item.id)"
                              placeholder="{{item.nom}}" [disabled]="!item.actif || isHisto"
                              (ngModelChange)="changeFiliere()"></textarea>
            
                      </div>
                  </div>
          </div>
          <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
              <button  type="button" class=" btn-close btn-valider" (click)="validerChampSupp();common.closeModal();">
                  Valider
              </button>
              <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler </button>
          </div>
    </div>
</ng-template>

  